// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2d528","questions":"styles_questions__3Kh3H","footer":"styles_footer__2WbA1"};